<template>
  <div :class="small ? 'small' : ''">
    <div class="badge">
      <LogoSvg class="logo"/>
      <div class="badge-name">AMBASSADOR</div>
      <div class="hashtag">#explore_and_earn</div>
    </div>
  </div>
</template>

<script>
import LogoSvg from "../../public/img/logo.svg";

export default {
  name: 'LogoBlock',
  props: ['small'],
  data() {
    return {
    };
  },
  components: {
    LogoSvg
  },
  methods: {
  },
};
</script>


<style scoped>
.badge {
  width: 250px;
  box-sizing: border-box;
  margin: 0 0 50px 75px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-content: stretch;
  align-items: center;
  border-radius: 0.5em 3em;
  text-align: center;
  padding: 0 3.5em;
  font-weight: 500;
  background: rgba(243, 136, 37, 0.75);
  position: relative;
}
.logo {
  width: 165px;
  margin: 0 0 0 -255px;
}
.badge-name {
  color: white;
  font-size: 20px;
  margin: -10px 0 15px 0;
}
.hashtag {
  display: inline-block;
  padding: 0.2em;
  background: #000;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  margin: 0 0 -10px 0;
}
.small .badge {
  width: 150px;
}
.small .logo {
  width: 100px;
  margin: 0 0 0 -153px;
}
.small .badge-name {
  font-size: 12px;
  margin: -10px 0 10px 0;
}
.small .hashtag {
  font-size: 10px;
}
</style>
